import { RootState } from "../rootReducer"

export const selectOperatorStatus = (state: RootState) => state.userOperator.status.data?.Value
export const selectOperatorStatusState = (state: RootState) => state.userOperator.status
export const selectIsOperatorConnected = (state: RootState) => state.userOperator.connected
export const selectOperatorStatuses = (state: RootState) => state.userOperator.statuses
